/**
 * Адреса прав Platform (RP-A3). `access/me/capabilities`, `access/matrix`,
 * `access/roles/{role}` — ручки пакета Kalmykov Access на `/api/platform/v1`;
 * `access/roles/{role}/resources` — допуск роли к ресурсам (только
 * `system_admin`). `/internal/access/**` (решения за службы) клиенту не нужен
 * и сюда не попадает.
 */
const role = (name: string) => encodeURIComponent(name)

export const PLATFORM_ACCESS_URLS = {
  mine: '/api/platform/v1/access/me/capabilities',
  matrix: '/api/platform/v1/access/matrix',
  rolePermissions: (name: string) => `/api/platform/v1/access/roles/${role(name)}`,
  roleResources: (name: string) => `/api/platform/v1/access/roles/${role(name)}/resources`,
  /** Стартовый набор прав роли (RP-FB5): подсказка для галочек, сама ничего не меняет. */
  roleDefaults: (name: string) => `/api/platform/v1/access/roles/${role(name)}/defaults`,
} as const
